import React, { useEffect, useState } from "react";
// import UsersList from "./UsersList";
import DepenseSchema from "./DepenseSchema";
import Files from "./Files";
import Select from "react-select";
import "./ExpenseFields.css";
import { apiFetch } from "../utils/apiClient";
import ModernDatePicker from "./ModernDatePicker";
import { ExternalLink, Loader2, Plus, Trash2 } from "lucide-react";

const creerFormationLiee = (formation, commentaireFormation = "") => ({
  participationFormationId: formation._id,
  numeroFormulaire: formation.numeroFormulaire,
  dateFormation: formation.dateDebut,
  descriptionObjectifs: formation.descriptionObjectifs,
  ville: formation.ville,
  provincePays: formation.provincePays,
  nombreJours: formation.nombreJours,
  commentaireFormation,
});

const formaterDateFormation = (date) => {
  if (!date) return "—";

  const valeur = new Date(date);
  if (Number.isNaN(valeur.getTime())) return date;

  return new Intl.DateTimeFormat("fr-CA", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(valeur);
};

const Etape2 = ({
  renderError,
  user,
  formData,
  handleChange,
  setFormData,
  isReadOnly,
  page,
  formationsDisponibles,
  formationsLoading,
  formationsLookupError,
  clearFormationsError,
}) => {
  const [funds, setFunds] = useState([]);
  const [centreCouts, setCentreCout] = useState([]);

  useEffect(() => {
  async function fetchData() {
    try {
      const [fundsRes, centreCoutRes] = await Promise.all([
        apiFetch(`${process.env.REACT_APP_API_BASE_URL}/Funds`),
        apiFetch(`${process.env.REACT_APP_API_BASE_URL}/CentreCout`),
      ]);

      const [fundsData, centreCoutData] = await Promise.all([
        fundsRes.json(),
        centreCoutRes.json(),
      ]);

      setFunds(fundsData);
      setCentreCout(centreCoutData);
    } catch (error) {
      console.error("Erreur lors du chargement des données :", error);
    }
  }

  fetchData();
}, []);

 

  // Recalculer 'montantVisaConseil' quand 'depenses' change
  useEffect(() => {
    const newMontantVisaConseil = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Visa du Conseil")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      visaConseil: {
        ...prevFormData.visaConseil,
        montantTotalDepensesVisa: parseFloat(newMontantVisaConseil.toFixed(2)),
      },
    }));
  }, [formData.depenses, setFormData]);

  const formationsLiees = formData.formationsLiees || [];
  const formationsAAfficher =
    formationsLiees.length > 0
      ? formationsLiees
      : [{ participationFormationId: "", commentaireFormation: "" }];

  const idsSelectionnes = new Set(
    formationsLiees
      .map((formation) => String(formation.participationFormationId || ""))
      .filter(Boolean),
  );

  const modifierFormationLiee = (index, changements) => {
    setFormData((currentData) => {
      const formations = [...(currentData.formationsLiees || [])];

      if (formations.length === 0 && index === 0) {
        formations.push({
          participationFormationId: "",
          commentaireFormation: "",
        });
      }

      formations[index] = {
        ...formations[index],
        ...changements,
      };

      return {
        ...currentData,
        formationsLiees: formations,
      };
    });
    clearFormationsError?.();
  };

  const selectionnerFormation = (index, participationFormationId) => {
    const formationDisponible = formationsDisponibles.find(
      (formation) => String(formation._id) === participationFormationId,
    );

    if (!formationDisponible) {
      modifierFormationLiee(index, {
        participationFormationId: "",
        numeroFormulaire: "",
        dateFormation: "",
        descriptionObjectifs: "",
        ville: "",
        provincePays: "",
        nombreJours: null,
      });
      return;
    }

    const commentaireFormation =
      formationsAAfficher[index]?.commentaireFormation || "";
    modifierFormationLiee(
      index,
      creerFormationLiee(formationDisponible, commentaireFormation),
    );
  };

  const ajouterFormation = () => {
    setFormData((currentData) => ({
      ...currentData,
      formationsLiees: [
        ...(currentData.formationsLiees || []),
        { participationFormationId: "", commentaireFormation: "" },
      ],
    }));
    clearFormationsError?.();
  };

  const retirerFormation = (index) => {
    setFormData((currentData) => ({
      ...currentData,
      formationsLiees: (currentData.formationsLiees || []).filter(
        (_, formationIndex) => formationIndex !== index,
      ),
    }));
    clearFormationsError?.();
  };

  const nombreFormationsSelectionnees = idsSelectionnes.size;
  const contientSelectionVide = formationsLiees.some(
    (formation) => !formation.participationFormationId,
  );
  const peutAjouterFormation =
    !isReadOnly &&
    !formationsLoading &&
    formationsDisponibles.length > 0 &&
    formationsLiees.length > 0 &&
    !contientSelectionVide &&
    nombreFormationsSelectionnees < formationsDisponibles.length;

  /************************************************************************/

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Information générale
        </h1> */}
      <dl className="ml-auto grid w-full max-w-md grid-cols-1 rounded-lg border border-gray-200 bg-white text-sm shadow-sm sm:w-fit sm:max-w-none sm:grid-cols-[auto_auto]">
        <div className="min-w-0 px-4 py-3 sm:px-5">
          <dt className="text-xs font-medium text-slate-500">Numéro de formulaire</dt>
          <dd className="mt-1 break-words font-semibold text-slate-800">
            {formData.numeroFormulaire}
          </dd>
        </div>
        <div className="min-w-0 border-t border-gray-100 px-4 py-3 sm:border-l sm:border-t-0 sm:px-5">
          <dt className="text-xs font-medium text-slate-500">Date</dt>
          <dd className="mt-1 font-medium text-slate-700">
            {formData.dateSoumission
              ? new Intl.DateTimeFormat("fr-CA", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                  timeZone: "UTC",
                }).format(new Date(formData.dateSoumission))
              : "—"}
          </dd>
        </div>
      </dl>

      <div className="my-6 flex w-full justify-center">
  <div className="w-fit max-w-full rounded-lg border border-blue-100 border-l-4 border-l-blue-500 bg-blue-50 px-4 py-3 text-blue-800 shadow-sm">
    <p className="flex items-center gap-2 text-lg font-semibold">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 flex-none text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Réclamation mensuelle de dépenses d'emploi
    </p>
  </div>
</div>

      <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-red-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8c-1.657 0-3 1.343-3 3 0 2.667 3 4 3 4s3-1.333 3-4c0-1.657-1.343-3-3-3zM12 2a10 10 0 100 20 10 10 0 000-20z"
      />
    </svg>
    Compte budgétaire
  </p>
</div>

      <div className="mt-5 w-full rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
      <p className="text-sm text-slate-600">
        Veuillez inscrire votre compte budgétaire par défaut.
      </p>

      <div className="expense-fields mt-5 grid w-full grid-cols-1 md:grid-cols-[minmax(0,28rem)_minmax(0,28rem)]">
        <div className="w-full min-w-0 md:col-start-1">
          <label
            htmlFor="funds"
            className="mb-1.5 block text-sm font-medium text-slate-700"
          >
            Fonds :
          </label>
          {/* <select
            id="funds"
            name="funds"
            value={formData.funds}
            onChange={handleChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            disabled={isReadOnly}
          >
            <option value="">Selectionner</option>
            {funds.map((fund) => (
              <option key={fund._id} value={fund.value}>
                {fund.value}
              </option>
            ))}
          </select> */}

          <Select
            id="funds"
            name="funds"
            options={funds.map((fund) => ({
              value: fund.value,
              label: String(fund.value),
            }))}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "funds",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            placeholder="Sélectionner"
            value={
              formData.funds
                ? { value: formData.funds, label: String(formData.funds) }
                : null
            }
            isClearable
            menuPlacement="auto"
            className="react-select-container"
            classNamePrefix="react-select"
            filterOption={(option, inputValue) =>
              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
            }
            isDisabled={isReadOnly}
          />
          {/* {renderError("funds")} */}
        </div>
        <div className="w-full min-w-0">
          <label
            htmlFor="centreCout"
            className="mb-1.5 block text-sm font-medium text-slate-700"
          >
            Centre de coût :
          </label>
          {/* <select
            id="centreCout"
            name="centreCout"
            value={formData.centreCout}
            onChange={handleChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
            disabled={isReadOnly}
          >
            <option value="">Selectionner</option>
            {centreCouts.map((centreCout) => (
              <option key={centreCout._id} value={centreCout.value}>
                {centreCout.value}
              </option>
            ))}
          </select> */}
          <Select
            id="centreCout"
            name="centreCout"
            options={centreCouts.map((centreCout) => ({
              value: centreCout.value,
              label: String(centreCout.value),
            }))}
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "centreCout",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            placeholder="Sélectionner"
            value={
              formData.centreCout
                ? {
                    value: formData.centreCout,
                    label: String(formData.centreCout),
                  }
                : null
            }
            isClearable
            menuPlacement="auto"
            className="react-select-container"
            classNamePrefix="react-select"
            filterOption={(option, inputValue) =>
              option.label.toLowerCase().startsWith(inputValue.toLowerCase())
            }
            isDisabled={isReadOnly}
          />
          {/* {renderError("centreCout")} */}
        </div>
        <div className="w-full min-w-0">
          <label
            htmlFor="adresse"
            className="block text-sm font-medium text-slate-700"
          >
            Ordre (optionnel) :
          </label>
          <input
            type="text" // switched to text for better control
            id="ordre"
            name="ordre"
            maxLength={6} // limit length
            value={formData.ordre}
            onChange={(e) => {
        const val = e.target.value;
        if (/^\d*$/.test(val)) {
          handleChange(e);
        }
      }}
      onKeyDown={(e) => {
    // Autoriser uniquement les touches numériques, backspace, delete, flèches
    if (
      !(
        (e.key >= '0' && e.key <= '9') ||
        e.key === 'Backspace' ||
        e.key === 'Delete' ||
        e.key === 'ArrowLeft' ||
        e.key === 'ArrowRight' ||
        e.key === 'Tab'
      )
    ) {
      e.preventDefault();
    }
  }}
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
            readOnly={isReadOnly}
          />
        </div>
      </div>
      </div>

      <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-purple-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8c-1.657 0-3 1.343-3 3 0 2.667 3 4 3 4s3-1.333 3-4c0-1.657-1.343-3-3-3zM12 2a10 10 0 100 20 10 10 0 000-20z"
      />
    </svg>
    Dépenses
  </p>
</div>


      <DepenseSchema
        renderError={renderError}
        user={user}
        formData={formData}
        handleChange={handleChange}
        setFormData={setFormData}
        funds={funds}
        centreCouts={centreCouts}
        isReadOnly={isReadOnly}
        page={page}
      />

      {/* {((formData.depenses.some(depense =>
          depense.rows.some(row => row.typeDepenses === "Visa du Conseil")
        )) || 
        (formData.achatsCarteCréditProfessionnelle === "oui") )&& ( */}

      {formData.achatsCarteCréditProfessionnelle &&
        formData.achatsCarteCréditProfessionnelle === "oui" && (
          <div>
            <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-indigo-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7M12 20c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8z"
      />
    </svg>
    Visa du Conseil
  </p>
</div>


            <div className="mt-5 grid w-full grid-cols-1 gap-5 rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 md:grid-cols-[minmax(0,28rem)_minmax(0,28rem)]">
              <div className="w-full min-w-0">
                <label
                  htmlFor="montantTotalReleveVisa"
                  className="block text-sm font-medium leading-5 text-slate-700 md:min-h-10"
                >
                  Inscrire le montant total selon le relevé de Visa{" "}
                  <span className="text-red-500">*</span> :
                </label>
                <div className="relative">
                  <input
                    type="text"
                    step="0.01"
                    id="montantTotalReleveVisa"
                    name="montantTotalReleveVisa"
                    value={formData.visaConseil.montantTotalReleveVisa ?? ""}
                    // onChange={handleChange}
                    onChange={(e) => {
                      // On normalise aussi à la saisie (remplace la virgule par un point)
                      handleChange({
                        target: {
                          name: "montantTotalReleveVisa",
                          value: e.target.value.replace(',', '.'),
                        },
                      });
                    }}
                        onKeyDown={(e) => {
                          // Autoriser uniquement les touches numériques, backspace, delete, flèches
                          if (
                              !(
                                (e.key >= '0' && e.key <= '9') ||
                                e.key === ',' ||
                                e.key === '.' ||
                                e.key === '-' ||
                                e.key === 'Backspace' ||
                                e.key === 'Delete' ||
                                e.key === 'ArrowLeft' ||
                                e.key === 'ArrowRight' ||
                                e.key === 'Tab'
                              )
                          ) {
                            e.preventDefault();
                          }
                        }}
                    // onBlur={(e) => {
                    //   const value = parseFloat(e.target.value || 0).toFixed(2);
                    //   handleChange({
                    //     target: {
                    //       name: "montantTotalReleveVisa",
                    //       value,
                    //     },
                    //   });
                    // }}
                    onBlur={(e) => {
                      const rawValue = e.target.value.replace(',', '.'); // conversion
                      const value = parseFloat(rawValue || 0).toFixed(2);

                      handleChange({
                        target: {
                          name: "montantTotalReleveVisa",
                          value,
                        },
                      });
                    }}
                    required
                    readOnly={
                      isReadOnly &&
                      !(
                        page === "Mes taches" &&
                        formData.etatDemande === "En traitement"
                      )
                    }
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 pr-10 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  />
                  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
                </div>


                {renderError("montantTotalReleveVisa")}
              </div>

              <div className="w-full min-w-0">
                <label
                  htmlFor="montantTotalDepensesVisa"
                  className="block text-sm font-medium leading-5 text-slate-700 md:min-h-10"
                >
                  Montant total des dépenses Visa :
                </label>
                <div className="relative">
  <input
    type="text"
    id="montantTotalDepensesVisa"
    name="montantTotalDepensesVisa"
    value={
      formData.visaConseil.montantTotalDepensesVisa !== null &&
      formData.visaConseil.montantTotalDepensesVisa !== undefined
        ? parseFloat(formData.visaConseil.montantTotalDepensesVisa).toFixed(2)
        : ""
    }
    disabled
    className="mt-1.5 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 pr-10 text-[15px] text-slate-700 shadow-sm outline-none"
  />
  <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
</div>

                
              </div>
              <div className="w-full max-w-2xl md:col-span-2">
              <Files
                renderError={renderError}
                formData={formData}
                setFormData={setFormData}
                section="Visa du Conseil"
                isReadOnly={isReadOnly}
                user={user}
                page={page}
              />
              </div>
            </div>
          </div>
        )}

      {formData.depensesEtrReclamer &&
        formData.depensesEtrReclamer === "oui" && (
          <div>
            <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-orange-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 10h18M3 14h18M5 6h14M5 18h14"
      />
    </svg>
    407 ETR
  </p>
</div>


            <div className="mt-5 w-full rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
              <div className="w-full max-w-2xl">
              <Files
                renderError={renderError}
                formData={formData}
                setFormData={setFormData}
                section="407 ETR"
                isReadOnly={isReadOnly}
                user={user}
                page={page}
              />
              </div>
            </div>
          </div>
        )}

      {formData.depensesActiviteExterne &&
        formData.depensesActiviteExterne === "oui" &&
        formData.formationVersion !== 2 && (
          <div>
            <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-teal-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 14l9-5-9-5-9 5 9 5zm0 0v6m0-6L3 9m9 5l9-5"
      />
    </svg>
    Formation
  </p>
</div>

            <div className="mt-5 grid w-full grid-cols-1 gap-5 rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 md:grid-cols-[minmax(0,28rem)_minmax(0,34rem)]">
              <div className="w-full min-w-0 max-w-md">
                <label
                  htmlFor="dateFormation"
                  className="block text-sm font-medium text-slate-700"
                >
                  Date <span className="text-xl text-red-900">*</span> :
                </label>
                <ModernDatePicker
                  value={formData.formation.dateFormation}
                  onChange={(date) =>
                    handleChange({
                      target: { name: "dateFormation", value: date },
                    })
                  }
                  disabled={isReadOnly}
                  ariaLabel="Choisir la date de la formation"
                />
                {renderError("dateFormation")}
              </div>

              <div className="w-full min-w-0 max-w-xl">
                <label
                  htmlFor="nomFormation"
                  className="block text-sm font-medium text-slate-700"
                >
                  Nom de la formation, colloque ou activité externe{" "}
                  <span className="text-xl text-red-900">*</span> :
                </label>
                <input
                  type="text"
                  id="nomFormation"
                  name="nomFormation"
                  value={formData.formation.nomFormation}
                  onChange={handleChange}
                  required
                  // disabled
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  readOnly={isReadOnly}
                />
                {renderError("nomFormation")}
              </div>
              <div className="w-full min-w-0 max-w-xl">
                <label
                  htmlFor="commentaireFormation"
                  className="block text-sm font-medium text-slate-700"
                >
                  Commentaires :
                </label>

                <textarea
                  placeholder="Ajoutez un commentaire..."
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  rows="3"
                  id="commentaireFormation"
                  name="commentaireFormation"
                  value={formData.formation.commentaireFormation}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                />
                {/* {renderError("commentaireFormation")} */}
              </div>

              <Files
                renderError={renderError}
                formData={formData}
                setFormData={setFormData}
                section="formation"
                isReadOnly={isReadOnly}
                user={user}
                page={page}
              />
            </div>
          </div>
        )}

      {formData.depensesActiviteExterne === "oui" &&
        formData.formationVersion === 2 && (
          <div>
            <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
              <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-2 h-4 w-4 text-teal-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0v6m0-6L3 9m9 5l9-5"
                  />
                </svg>
                Formation
              </p>
            </div>

            <div className="mt-5 w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
              <div className="border-b border-slate-200 px-4 py-4 sm:px-5">
                <h3 className="text-sm font-semibold text-slate-900">
                  Formations liées à cette réclamation
                </h3>
                <p className="mt-1 text-xs text-slate-500">
                  Les renseignements proviennent des demandes de participation
                  approuvées.
                </p>
              </div>

              {formationsLoading && (
                <div
                  className="flex items-center gap-2 px-4 py-5 text-sm text-slate-600 sm:px-5"
                  role="status"
                >
                  <Loader2
                    className="h-4 w-4 animate-spin"
                    aria-hidden="true"
                  />
                  Recherche des formations disponibles…
                </div>
              )}

              {!formationsLoading && formationsLookupError && (
                <div
                  className="m-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 sm:m-5"
                  role="alert"
                >
                  {formationsLookupError}
                </div>
              )}

              {!formationsLoading &&
                (formationsLiees.length > 0 ||
                  (!formationsLookupError &&
                    formationsDisponibles.length > 0)) && (
                  <div className="divide-y divide-slate-200">
                    {formationsAAfficher.map((formation, index) => {
                      const participationFormationId = String(
                        formation.participationFormationId || "",
                      );
                      const optionsDisponibles = formationsDisponibles.filter(
                        (formationDisponible) => {
                          const id = String(formationDisponible._id);
                          return (
                            id === participationFormationId ||
                            !idsSelectionnes.has(id)
                          );
                        },
                      );
                      const afficherSelecteur =
                        !isReadOnly && formationsDisponibles.length > 1;
                      const afficherRetrait =
                        !isReadOnly &&
                        (formationsLiees.length > 0 || participationFormationId) &&
                        !(
                          formationsDisponibles.length === 1 &&
                          formationsLiees.length === 1 &&
                          participationFormationId
                        );
                      const informationsFormation = [
                        formation.descriptionObjectifs,
                        [formation.ville, formation.provincePays]
                          .filter(Boolean)
                          .join(", "),
                        formation.nombreJours
                          ? `${formation.nombreJours} jour${
                              Number(formation.nombreJours) > 1 ? "s" : ""
                            }`
                          : "",
                      ]
                        .filter(Boolean)
                        .join("\n");
                      const pageParticipation =
                        user?.id === formData.userId
                          ? "Mes demandes"
                          : "Mes taches";
                      const lienParticipation = formation.numeroFormulaire
                        ? `/participationFormation?numeroFormulaire=${encodeURIComponent(
                            formation.numeroFormulaire,
                          )}&page=${encodeURIComponent(pageParticipation)}`
                        : "";

                      return (
                        <section
                          key={participationFormationId || `formation-${index}`}
                          className="relative px-4 py-5 sm:px-5"
                        >
                          <div className={`grid grid-cols-1 items-start gap-4 ${
                            afficherRetrait
                              ? "xl:grid-cols-[minmax(21rem,1.4fr)_minmax(18rem,1fr)_minmax(18rem,1fr)_2rem]"
                              : "xl:grid-cols-[minmax(21rem,1.4fr)_minmax(18rem,1fr)_minmax(18rem,1fr)]"
                          }`}>
                            <div className="min-w-0">
                              <label
                                htmlFor={`formation-demande-${index}`}
                                className="block text-sm font-medium text-slate-700"
                              >
                                Demande <span className="text-red-500">*</span>
                              </label>

                              {afficherSelecteur ? (
                                <select
                                  id={`formation-demande-${index}`}
                                  value={participationFormationId}
                                  onChange={(event) =>
                                    selectionnerFormation(
                                      index,
                                      event.target.value,
                                    )
                                  }
                                  className="mt-1.5 h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                                >
                                  <option value="">
                                    Sélectionner une formation
                                  </option>
                                  {optionsDisponibles.map((option) => (
                                    <option key={option._id} value={option._id}>
                                      {option.numeroFormulaire} — {formaterDateFormation(option.dateDebut)}
                                    </option>
                                  ))}
                                </select>
                              ) : formation.numeroFormulaire ? (
                                <a
                                  id={`formation-demande-${index}`}
                                  href={lienParticipation}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="mt-1.5 inline-flex min-h-11 w-full items-center justify-between gap-2 rounded-lg border border-slate-300 bg-slate-50 px-3 py-2 text-[15px] font-semibold text-slate-800 transition hover:border-slate-400 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                >
                                  <span className="min-w-0 break-words">
                                    {formation.numeroFormulaire} — {formaterDateFormation(formation.dateFormation)}
                                  </span>
                                  <ExternalLink
                                    className="h-4 w-4 shrink-0 text-slate-500"
                                    aria-hidden="true"
                                  />
                                </a>
                              ) : (
                                <p className="mt-1.5 text-sm text-slate-500">
                                  Aucune formation sélectionnée.
                                </p>
                              )}

                              {afficherSelecteur &&
                                formation.numeroFormulaire && (
                                  <a
                                    href={lienParticipation}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-slate-700 underline decoration-slate-300 underline-offset-4 hover:text-slate-900"
                                  >
                                    Ouvrir {formation.numeroFormulaire}
                                    <ExternalLink
                                      className="h-3.5 w-3.5"
                                      aria-hidden="true"
                                    />
                                  </a>
                                )}
                            </div>

                            <div className="min-w-0">
                              <label
                                htmlFor={`formation-informations-${index}`}
                                className="block text-sm font-medium text-slate-700"
                              >
                                Informations de la formation
                              </label>
                              <textarea
                                id={`formation-informations-${index}`}
                                value={informationsFormation}
                                readOnly
                                rows={3}
                                className="mt-1.5 min-h-[84px] w-full resize-none rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-[15px] leading-5 text-slate-700 outline-none"
                              />
                            </div>

                            <div className="min-w-0">
                              <label
                                htmlFor={`formation-commentaire-${index}`}
                                className="block text-sm font-medium text-slate-700"
                              >
                                Commentaires
                              </label>
                              <textarea
                                id={`formation-commentaire-${index}`}
                                value={formation.commentaireFormation || ""}
                                onChange={(event) =>
                                  modifierFormationLiee(index, {
                                    commentaireFormation: event.target.value,
                                  })
                                }
                                readOnly={isReadOnly}
                                rows={3}
                                placeholder="Ajoutez un commentaire…"
                                className={`mt-1.5 min-h-[84px] w-full resize-y rounded-lg border px-3 py-2.5 text-[15px] leading-5 outline-none transition ${
                                  isReadOnly
                                    ? "border-slate-200 bg-slate-50 text-slate-700"
                                    : "border-slate-300 bg-white text-slate-800 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                                }`}
                              />
                            </div>

                            {afficherRetrait && (
                              <div className="flex min-h-11 items-center justify-end xl:mt-6">
                                  <button
                                    type="button"
                                    onClick={() => retirerFormation(index)}
                                    title="Retirer cette formation"
                                    aria-label="Retirer cette formation"
                                    className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-red-600 transition hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-100"
                                  >
                                    <Trash2
                                      className="h-4 w-4"
                                      aria-hidden="true"
                                    />
                                  </button>
                              </div>
                            )}
                          </div>
                        </section>
                      );
                    })}

                    {!isReadOnly && (
                      <div className="p-3 sm:p-4">
                        <button
                          type="button"
                          onClick={ajouterFormation}
                          disabled={!peutAjouterFormation}
                          className="flex w-full items-center justify-center gap-2 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-45"
                        >
                          <Plus className="h-4 w-4" aria-hidden="true" />
                          Ajouter une autre formation
                        </button>
                      </div>
                    )}
                  </div>
                )}

              {!formationsLookupError && renderError("formationsLiees")}
            </div>
          </div>
        )}
    </div>
  );
};

export default Etape2;
